/** A url-safe slug derived from a campaign name. */
export function campaignSlug(name: string): string {
  const base = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return base || 'new-campaign';
}

/** The unique onboarding link brands can share with creators outside the network. */
export function onboardingLink(name: string): string {
  return `https://app.twiva.io/onboard/${campaignSlug(name)}`;
}